<template>
    <span class="yushu-image" :style="style" style="display: inline-block;" :class="{'circle' : circle}">
        <el-image filt="cover" :src="Utils.getResourceUrl(url)" :style="style">
            <div slot="error" class="image-slot">
                <img :src="require('@/web-framework/assets/images/course-default.png')">
            </div>
        </el-image>
    </span>
</template>
<script>
export default {
    name: 'YushuImage',
    props: {
        url: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: '60x60'
        },
        circle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            style: {},
        }
    },
    mounted() {
        if (this.size && this.size.length > 0) {
            let p = this.size.split('x');

            let width = "60";
            let height = "60";

            if (p.length == 2) {
                width = p[0].trim();
                height = p[1].trim();
            } else if (p.length == 1) {
                width = p[0];
                height = p[0];
            }

            let styleWidth = '';
            let styleHeight = '';
            if (width.endsWith("%")) {
                styleWidth = width;
            } else {
                styleWidth = width + 'px';
            }

            if (height.endsWith("%")) {
                styleHeight = height;
            } else {
                styleHeight = height + 'px';
            }

            let style = { width: styleWidth, height: styleHeight };
            this.style = style;
            Vue.set(this, 'style', style);
        }
    },
    methods: {
    }
}
</script>
<style lang="less" scoped>
.yushu-image {
    width: 100%;
    height: 100%;
    &.circle {
        .el-image {
            border-radius: 50%;
        }
    }
    /deep/.el-image {
        width: 100%;
        height: 100%;
        .image-slot {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>